import { AIChatMessage } from "@tellescope/ui";
import { AskAIVisualization } from "./AskAIVisualization";
import type { ParsedChatMessage } from "../types";

interface SenderInfo {
  name: string;
}

interface CachedMessageProps {
  message: ParsedChatMessage;
  senderInfo: SenderInfo;
}

export const CachedMessage = ({ message, senderInfo }: CachedMessageProps) => {
  const msgText = message.payload.type === "text" || message.payload.type === "error" ? message.payload.content : "";
  const msgVisualization =
    message.payload.type === "analytics-result"
      ? { inference: message.payload.inference, data: message.payload.data as Array<Record<string, unknown>> }
      : undefined;

  return (
    <div className="max-w-3xl mx-auto space-y-2">
      {msgText && (
        <AIChatMessage
          role={message.role}
          content={msgText}
          timestamp={message.timestamp ?? new Date()}
          sender={message.role === "user" ? senderInfo : undefined}
          onCopy={() => navigator.clipboard.writeText(msgText)}
        />
      )}
      {msgVisualization && (
        <div className={msgText ? "ml-11 mt-4 mb-6" : "mb-6"}>
          <AskAIVisualization visualization={msgVisualization} />
        </div>
      )}
    </div>
  );
};
